module.exports = __webpack_public_path__ + "static/media/400338_01.76fb17fc.png";